// Per-device preferences (theme). Never used for documents.

export type Theme = 'light' | 'dark' | 'auto';

const KEY = 'ns-pdf-theme';

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Storage blocked: the preference just won't persist.
  }
}

export function getTheme(): Theme {
  const v = read(KEY);
  return v === 'light' || v === 'dark' ? v : 'auto';
}

export function effectiveTheme(): 'light' | 'dark' {
  const theme = getTheme();
  if (theme !== 'auto') return theme;
  return matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(theme: Theme = getTheme()): void {
  if (theme === 'auto') delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = theme;
}

export function toggleTheme(): 'light' | 'dark' {
  const next = effectiveTheme() === 'dark' ? 'light' : 'dark';
  write(KEY, next);
  applyTheme(next);
  return next;
}
